// extracted by mini-css-extract-plugin
export default {"container":"AdminLayout_container__vyB50","sidebar":"AdminLayout_sidebar__4s8oz","content":"AdminLayout_content__Mxzjm"};